export default __webpack_public_path__ + "static/media/bg.134f7bc4.jpg";